(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regex = require("../helper/regex");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var $ = jQuery;
var Newsletter = /*#__PURE__*/function () {
  function Newsletter() {
    var _this = this;
    _classCallCheck(this, Newsletter);
    this.form = document.getElementById('mc_newsletter_form');
    this.input = document.getElementById('mc_newsletter-email');
    if (!this.form || !this.input) {
      return;
    }

    // this.removeMessage();

    this.form.addEventListener('submit', this.submit.bind(this));
    $('body').on('submit', '#mc_newsletter_form', function (e) {
      _this.form = document.getElementById('mc_newsletter_form');
      _this.input = document.getElementById('mc_newsletter-email');
      _this.submit(e);
    });
  }
  _createClass(Newsletter, [{
    key: "submit",
    value: function submit(e) {
      var formSubmitButton = this.form.querySelector('button[type="submit"]');
      e.preventDefault();
      console.log(this);
      var noticeEl = this.form.querySelector('.hpy_notice');
      if (noticeEl) noticeEl.parentNode.removeChild(noticeEl);
      if (!this.validate()) {
        var notice = document.createElement('div');
        notice.classList.add('hpy_notice', 'error');
        notice.innerText = 'Email address not valid';
        formSubmitButton.after(notice);
        return;
      }

      // formSubmitButton.style.opacity = '0.7';
      formSubmitButton.style.pointerEvents = 'none';
      jQuery.ajax({
        type: 'POST',
        data: {
          action: 'hpy_mc_add_new_contact',
          mc_email: this.input.value,
          mc_tag: this.form.querySelector('#mc_newsletter_tag').value,
          mc_name: this.form.querySelector('#mc_newsletter-name') ? this.form.querySelector('#mc_newsletter-name').value : '',
          mc_redirect: this.form.getAttribute('data-redirect')
        },
        context: this,
        dataType: 'json',
        url: hpy.ajaxurl,
        success: function success(response) {
          console.log(response);
          if (response.redirect) {
            // window.open(response.redirect);
            window.location.href = response.redirect;

            // window.location.href = response.redirect;
            // return;
          }

          if (response.success || response.redirect) {
            this.form.innerHTML = "<span class=\"form_complete\">Thank you for Signing Up!</span>";
          } else {
            var errorMsg = '';
            var noticeColor = '';
            if (response.error.title === 'Member Exists') {
              this.form.innerHTML = "";
            }

            //Update notice
            switch (response.error.title) {
              case 'Invalid Resource':
                errorMsg = response.error.detail.includes('fake or invalid') ? response.error.detail : '';
                noticeColor = 'error';
                break;
              case 'Member Exists':
                errorMsg = 'You are already on our mailing list. Thank you for Signing Up!';
                noticeColor = 'valid';
                break;
            }
            if (!errorMsg.length) {
              errorMsg = 'Something went wrong, sorry!';
              noticeColor = 'info';
            }
            var _notice = document.createElement('div');
            _notice.classList.add('hpy_notice', noticeColor);
            _notice.innerText = errorMsg;
            formSubmitButton.after(_notice);
            this.form.prepend(_notice);
          }
        },
        complete: function complete() {
          formSubmitButton.style.opacity = '1';
          formSubmitButton.style.pointerEvents = 'all';
        },
        error: function error(a, b, c) {
          console.log({
            a: a,
            b: b,
            c: c
          });
          this.error(c);
        }
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      return this.input.value && this.input.value !== '' && (0, _regex.regexEmail)().test(this.input.value.toLowerCase());
    }
  }, {
    key: "error",
    value: function error(c) {
      alert(c ? c : 'Unspecified Error: Something went wrong');
    }
  }, {
    key: "removeMessage",
    value: function removeMessage() {
      var message = document.querySelector('.haymans--message');
      if (message) {
        setTimeout(function () {
          gsap.to(message, {
            xPercent: -100,
            duration: 0.6,
            ease: 'power2.out',
            onComplete: function onComplete() {
              var params = new URLSearchParams(document.location.search);
              // params.delete('mc4wp-subscribe');
              params["delete"]('email');
              var paramString = params.toString() ? '?' + params.toString() : '';
              window.history.replaceState({}, document.title, document.location.pathname + paramString);
            }
          });
        }, 4000);
      }
    }
  }]);
  return Newsletter;
}();
exports["default"] = Newsletter;

},{"../helper/regex":2}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regexEmail = regexEmail;
function regexEmail() {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
}

},{}],3:[function(require,module,exports){
"use strict";

var _Newsletter = _interopRequireDefault(require("./components/Newsletter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function ($) {
  var cartPanel = {
    panel: $('#generate-slideout-menu'),
    titleHeight: '',
    cartOptionsHeight: '',
    stateInitiated: false,
    errorMsgFixed: false,
    _titleHeight: function _titleHeight() {
      return $('.widget_shopping_cart>h2').outerHeight();
    },
    _cartOptionsHeight: function _cartOptionsHeight() {
      return $('.widget_shopping_cart_content').outerHeight();
    }
  };

  //   $('.hpy_togglecart').on('click', function(){
  //     if (cartPanel.stateInitiated && !$('.woocommerce-mini-cart__empty-message').length) {
  //       return;
  //     }

  //     if (!$('.woocommerce-mini-cart__empty-message').length) {
  //       cartPanel.titleHeight = cartPanel._titleHeight();
  //       // cartPanel.cartOptionsHeight = cartPanel._cartOptionsHeight();
  //       $('.product_list_widget').css('position', 'fixed')
  //       .css('top', (cartPanel.titleHeight + 20) + 'px')
  //       // .css('bottom', cartPanel.cartOptionsHeight + 'px')
  //       .css('bottom', '152' + 'px')
  //       .css('left', '20px')
  //       .css('right', '20px')
  //       .css('height', 'unset')
  //       .css('width', 'unset')
  //       .css('padding-bottom', '10px');
  //       cartPanel.stateInitiated = true;
  //       cartPanel.errorMsgFixed = false;
  //     } else {
  //       if (cartPanel.errorMsgFixed) {
  //         return;
  //       }
  //       cartPanel.titleHeight = cartPanel._titleHeight();
  //       cartPanel.cartOptionsHeight = cartPanel._cartOptionsHeight();

  //       $('.woocommerce-mini-cart__empty-message')
  //       .css('position', 'fixed')
  //       .css('top', (cartPanel.titleHeight + 20) + 'px')
  //       cartPanel.stateInitiated = false;
  //       cartPanel.errorMsgFixed = true;
  //     }
  //   })

  var homeSlider = {
    slider: $('.hpy_home_slider.elementor-products-grid ul'),
    init: function init() {
      homeSlider.slideCount = this.slider.find('li').length;
      // homeSlider.slidesToShow = this.slideCount >= 5 ? 5 : this.slideCount;
      $('.hpy_home_slider.elementor-products-grid ul').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: "<button type='button' class='slick-prev pull-left hpy-slick-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next pull-right hpy-slick-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
        // autoplay: true,
        // autoplaySpeed: 500,
      });
    }
  };

  if ($('body.home').length) {
    $('.menu-toggle').on('click', function () {
      $('.inside-header').toggleClass('toggled');
    });
  }
  function loaded() {
    if (cartPanel.panel.length) {
      $('.hpy_togglecart').css('pointer-events', 'all');
    }
    if (homeSlider.slider.length) {
      homeSlider.init();
    }
  }
  $(window).load(function () {
    loaded();
  });
  new _Newsletter["default"]();
})(jQuery, window);

},{"./components/Newsletter":1}]},{},[3]);
